import 'bulma/css/bulma.min.css';
import React from 'react';

class ExtranetLogo extends React.Component {

    render() {

        const logoStyle = {
            div: {
                marginTop: "20px"
            },
            text: {
                fontSize: "14PX",
                fontWeight: "bold",
                marginLeft: "2px"
            }
        };

        return (
            <div className="navbar-brand" style={logoStyle.div}>
                <a className="navbar-item" href="/Home/Index">
                    <img src="/css/img/ocpfsmaller2.png" alt="OCPF"></img>
                    <span style={logoStyle.text} className="has-text-grey">Extranet</span>
                </a>
            </div>
        );
    }
}

export default ExtranetLogo;